import { createFeature, createReducer, on } from '@ngrx/store';
import { WebshopPublicDataDto } from './webshop.models';
import * as WebshopActions from './webshop.actions';

export interface WebshopState {
  data: WebshopPublicDataDto | null;
  searchTerm: string;
  loading: boolean;
  error: any | null;
}

export const initialState: WebshopState = {
  data: null,
  searchTerm: '',
  loading: false,
  error: null,
};

export const webshopFeature = createFeature({
  name: 'webshop',
  reducer: createReducer(
    initialState,
    on(WebshopActions.loadWebshopData, (state) => ({
      ...state,
      loading: true,
      error: null,
    })),
    on(WebshopActions.loadWebshopDataSuccess, (state, {data}) => ({
      ...state,
      data,
      loading: false,
    })),
    on(WebshopActions.loadWebshopDataFailure, (state, {error}) => ({
      ...state,
      loading: false,
      error,
    })),
    on(WebshopActions.setSearchTerm, (state, {searchTerm}) => ({
      ...state,
      searchTerm,
    })),
  ),
});

export const {
  name,
  reducer,
  selectWebshopState,
  selectData,
  selectSearchTerm,
  selectLoading,
  selectError,
} = webshopFeature;
